export default __webpack_public_path__ + "static/media/bg5.846ce329.webp";